import { render } from "./Marker.svg?vue&type=template&id=7cdcc3f1"
const script = {}
script.render = render

export default script